import React, { useState, useEffect, useRef, useCallback, useReducer, useMemo } from "react";
import styled from "styled-components";
import GroupChatAPI from "../../../api/GroupChatAPI";
import Sidebar from "arui-feather/sidebar";
import TripsAPI from "../../../api/trips-api";
import toast from "react-hot-toast";
import FaqItemForm from "../tools/FaqItemForm";
import { useTranslation } from "react-i18next";

export default function FaqItemsPanel(props) {

    const [items, setItems] = useState([]);
    const [selectedId, setSelectedId] = useState(undefined);



    const { t, i18n } = useTranslation();
    let isRu = i18n.language == "ru";

    useEffect(() => {
        GroupChatAPI.getFaqItems().then(x => {
            setItems(x);
        });
    }, []);

    let xItems = items.map(x => {
        return {
            id: x.id,
            question: isRu ? x.ruName : x.enName,
            answer: isRu ? x.ruDescription : x.enDescription
        };
    });

    return (
        <Wrapper>


            <div className={'w-full'} >
                {xItems.map(x => (
                    <div key={x.id} className={'p-4 cursor-pointer shadow w-full border-gray-200 mt-2 mb-2'} style={{width: '100%'}} onClick={() => {
                        if (x.id == selectedId){
                            setSelectedId(undefined);
                            return;
                        }
                        setSelectedId(x.id);
                    }} >
                        <div className={'text-md font-bold'} >{x.question}</div>

                        {selectedId != x.id ? null :
                            <div className={'text-sm mt-2 mb-2'} > {x.answer}</div>
                        }

                    </div>
                ))}
            </div>

        </Wrapper>
    );
}

const Wrapper = styled.div`

`;